module.exports = __webpack_public_path__ + "static/media/bg-image-26.82b19dd7.jpg";